import { registerMlvExtension } from '../../core/app/mlvExtensions.js';

registerMlvExtension(() => {
  /* Sin efecto: valida la cadena de registro. Agregar aquí hooks globales si hiciera falta. */
});
